import { size } from 'lodash'

import api from 'common/api'

import types from './types'

const populateUnreadMessageFlag = () => (dispatch) => {
  api.get('/api/discussions?search=unread').then((discussions) => {
    const hasUnreadMessage = size(discussions) > 0
    dispatch(updateUnreadMessageFlag(hasUnreadMessage))
  })
}

const removeUnreadMessageFlag = () => updateUnreadMessageFlag(false)
const turnOnUnreadMessageFlag = () => updateUnreadMessageFlag(true)

const updateUnreadMessageFlag = (newValue) => ({
  type: types.UPDATE_HAS_UNREAD_MESSAGE,
  payload: newValue,
})

const actions = {
  populateUnreadMessageFlag,
  removeUnreadMessageFlag,
  turnOnUnreadMessageFlag,
  updateUnreadMessageFlag,
}

export default actions
